import { type FC, type PropsWithChildren, useEffect } from 'react'

import { useLocation, useNavigate } from 'react-router-dom'

import { changeLocation, changeNavigate } from '@/models/router.ts'

export interface Props {}

export const BrowserProvider: FC<PropsWithChildren<Props>> = ({ children }) => {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    changeLocation(location)
  }, [location])

  useEffect(() => {
    changeNavigate(navigate)
  }, [navigate])

  return children
}
